import React, { Component } from 'react';

interface IProps {
  teams_filter: any;
}

/**
 * A component that displays applied team filters as a horizontal list.
 *
 * - Each filter group is shown as a comma-separated list.
 * - Groups are separated by a vertical bar (`|`).
 * - Nothing is rendered if `teams_filter` is `null` or empty.
 *
 * @example
 * ```tsx
 * <DisplayFilterComponent
 *   teams_filter={{
 *     Department: ["Engineering", "Design"],
 *     Location: ["New York", "Berlin"]
 *   }}
 * />
 * // Renders: "Engineering, Design | New York, Berlin"
 * ```
 */
class DisplayFilterComponent extends Component<IProps> {
  /**
   * Reference to the filter container DOM element.
   *
   * Can be used for direct DOM interactions if needed.
   */
  filter_ref : any = React.createRef();
  /**
   * Renders filter groups into paragraph (`<p>`) elements.
   *
   * Each filter group:
   * - Displays its values joined by commas.
   * - Appends a vertical bar (`|`) separator if it's not the last group.
   *
   * @returns {JSX.Element[] | null} A list of filter elements, or `null` if no filters exist.
   */ 
  renderFilter = () => {
    let { teams_filter } = this.props;
    return teams_filter
      ? Object.keys(teams_filter).map((filter: string, i: number) => {
        let total_length = Object.keys(teams_filter).length - 1;
        return (
          <p className="filter-data" key={filter}>
            {teams_filter[filter]?.join(', ')} {i < total_length ? <b>|</b> : ''}{' '}
          </p>
        );
      })
      : null
  }

/**
   * Renders the filter display container.
   *
   * If `teams_filter` is non-empty, renders a wrapper div containing
   * the filters from {@link renderFilter}. Otherwise, returns `null`.
   *
   * @returns {JSX.Element | null} The rendered filter container or `null`.
   */
  render() {
    let { teams_filter } = this.props;

    return teams_filter &&  Object.keys(teams_filter).length > 0 ? (
      <>
        <div className={'filter-data-div'} ref={this.filter_ref} >
          {this.renderFilter()}
        </div>{' '}
      </>
    ) : null
  }
}

export default DisplayFilterComponent;